module.exports = __webpack_public_path__ + "static/media/sms_verification.b9ddf7d9.png";